export const de = {
	aboutMe: 'über mich',
	contact: 'kontakt'
};